import { FeatureFlag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';
import { Translation } from '@ps/web-shared-components';

import {
  TXTWCL_Continue_to_check_this_page_fo_ELL,
  TXTWCL_WeXre_currently_under_schedule_ELL,
  TXTWCL_WeXre_experiencing_temporary_s_ELL,
  TXTWCL_We_apologize_for_the_inconveni_ELL_1
} from './CasinoMaintenanceMessage.messages.json';
import styles from './CasinoMaintenanceMessage.scss';

export const CasinoMaintenanceMessage: React.FC = () => {
  const casinoScheduledDowntime = useFeature(FeatureFlag.CasinoScheduledDowntimeSplashPage);

  return (
    <div className={styles.messageContainer}>
      {casinoScheduledDowntime ? (
        <>
          <Translation {...TXTWCL_WeXre_currently_under_schedule_ELL}>
            {(message) => <h4 className={styles.message}>{message}</h4>}
          </Translation>
          <Translation {...TXTWCL_Continue_to_check_this_page_fo_ELL}>
            {(message) => <h4 className={styles.message}>{message}</h4>}
          </Translation>
        </>
      ) : (
        <>
          <Translation {...TXTWCL_WeXre_experiencing_temporary_s_ELL}>
            {(message) => <h4 className={styles.message}>{message}</h4>}
          </Translation>
          <Translation {...TXTWCL_We_apologize_for_the_inconveni_ELL_1}>
            {(message) => <h4 className={styles.message}>{message}</h4>}
          </Translation>
        </>
      )}
    </div>
  );
};
